export const WORKSPACE_ROUTES = {
  home: "/workspace",
  workbench: "/workspace/workbench/build",
  workbenchBuild: "/workspace/workbench/build",
  workbenchMonitor: "/workspace/workbench/monitor",
  workbenchModel: "/workspace/workbench/model",
  explore: "/workspace/explore",
  exploreQuiz: "/workspace/explore/quiz",
  exploreRecognition: "/workspace/explore/recognition",
  exploreSurface: "/workspace/explore/surface",
  exploreSelection: "/workspace/explore/selection",
  library: "/workspace/me/library",
  meCompound: "/workspace/me/compound",
  me: "/workspace/me",
  inbox: "/workspace/me/inbox",
  admin: "/workspace/admin",
  super: "/workspace/super",
  settings: "/workspace/settings",
} as const;

export function appendSearch(path: string, search: string) {
  return search ? `${path}${search}` : path;
}

const JOURNAL_LOCATION_QUERY_KEYS = [
  "journal_chapter",
  "journal_page",
] as const;

export function preserveJournalLocation(path: string, search?: string) {
  const currentSearch =
    search ?? (typeof window === "undefined" ? "" : window.location.search);
  if (!currentSearch) return path;

  const source = new URLSearchParams(currentSearch);
  const [pathname, existingSearch = ""] = path.split("?", 2);
  const target = new URLSearchParams(existingSearch);
  JOURNAL_LOCATION_QUERY_KEYS.forEach((key) => {
    const value = source.get(key);
    if (value) target.set(key, value);
  });
  const nextSearch = target.toString();
  return nextSearch ? `${pathname}?${nextSearch}` : pathname;
}

/** A community member's profile, inside 3.0 when browsing 3.0. */
export function communityProfilePath(id: number) {
  const inV3 =
    typeof window !== "undefined" &&
    window.location.pathname.startsWith("/workspace/v3");
  return inV3
    ? `/workspace/v3/explore/people/${id}`
    : `/workspace/explore/people/${id}`;
}
